import React from 'react';
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import {connect} from 'react-redux';
import _ from 'lodash';
import ApiActions from 'go/actions/api';
import {
  API_CONFIG_GET_SUCCESS,
  API_GRANT_BY_NUMBER_GET_SUCCESS,
  DYNAMIC_DATA_GET_ENTITY_SUCCESS,
  CLEAR_ALL_MSG,
} from 'common/types';
import {Loader, Container} from 'semantic-ui-react';
import Left from 'go/components/layout/left';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import GrantLandingSideNav from 'go/components/layout/GrantLandingSideNav';
import SummaryPage from 'go/components/dynamic/modules/grantLandingPage/summaryPage';
import {
  ENTITY_MAP,
  ROLE_MAP,
  GRANTS_LANDING_PAGE_NAV_ITEMS,
  SUBGRANTS_LANDING_PAGE_NAV_ITEMS,
  SUBGRANTS_LANDING_PAGE_NAV_ITEMS_WITH_SUBGRANT,
  ENTITY_PAGE_TYPE_GRANT,
  ENTITY_PAGE_TYPE_SUBGRANT,
  HMA_PROGRAMS,
} from 'app-ui-componentlibrary/dist/common/constants';
import {Alert} from 'componentLibrary';
import {isExternal} from 'go/security/permissions';
import {isProgramExternal} from 'common/utils';
import PermissionsUtility from 'go/security/permissionsUtility';

const initialState = {
  leftExpanded: true,
  grantData: {},
  subGrantData: {},
  loading: true,
  error: false,
  activeNavItem: null,
  config: {},
  allConfigs: {},
  scrollToElem: false,
};
import {EXCLUDEDFOS} from 'common/requestDetails/constants.js';

export class GrantLandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  //GMMGO-33025: fix when deep links are navigated from EMIS with invalid params
  stripInvalidParams(subGrantParam) {
    return subGrantParam && subGrantParam.indexOf('&') > 0
      ? subGrantParam.substring(0, subGrantParam.indexOf('&'))
      : subGrantParam;
  }

  componentDidMount() {
    const grantNumber = this.props.match.params.grantNumber;
    const subGrantNumber = this.stripInvalidParams(
      this.props.match.params.subGrantNumber
    );
    if (grantNumber) {
      this.initializeWithGrantNumber(grantNumber);
    } else if (subGrantNumber) {
      this.initializeWithSubGrantNumber(subGrantNumber);
    }
  }

  componentDidUpdate(prevProps) {
    let grantPath = 'match.params.grantNumber';
    let subGrantPath = 'match.params.subGrantNumber';

    if (
      _.get(this.props, grantPath) !== _.get(prevProps, grantPath) ||
      _.get(this.props, subGrantPath) !== _.get(prevProps, subGrantPath)
    ) {
      this.setState({
        ...initialState,
      });
      const grantNumber = _.get(this.props, grantPath);
      const subGrantNumber = _.get(this.props, subGrantPath);
      if (grantNumber) {
        this.initializeWithGrantNumber(grantNumber);
      } else if (subGrantNumber) {
        this.initializeWithSubGrantNumber(subGrantNumber);
      }
    }
  }

  componentWillUnmount() {
    this.props.clearAllMsg();
  }

  initializeWithGrantNumber(grantNumber) {
    let defaultConfig = _.get(this.props.match, 'params.config') || 'grantSummary';
    let defaultNavItem = _.find(
      GRANTS_LANDING_PAGE_NAV_ITEMS,
      (navItem) => defaultConfig.toLowerCase() === navItem.toLowerCase()
    );
    const token = this.props.token;
    const toggles = this.props.toggles;

    this.props
      .getGrantByGrantNumber(token, grantNumber)
      .then((res) => {
        if (res && res.type === API_GRANT_BY_NUMBER_GET_SUCCESS) {
          let foId = res.payload.fundingOpportunityId;
          const externalSSPShield = _.includes(this.props.toggles, 'externalSSPShield');

          if (
            externalSSPShield &&
            isExternal(this.props.permissions) &&
            _.includes(EXCLUDEDFOS, Number(foId))
          ) {
            //Display an error page if the user is external and the FOGrant is excluded from EXCLUDEDFOS list.
            this.setState({
              loading: false,
              error: true,
            });
          } else {
            this.setState(
              {
                grantData: res.payload,
              },
              () => {
                this.updateSelection(defaultNavItem, defaultConfig);
              }
            );
          }
        } else {
          this.setState({
            loading: false,
            error: true,
          });
        }
        return res;
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: true,
        });
      });
  }

  initializeWithSubGrantNumber(subGrantNumber) {
    let defaultConfig = _.get(this.props.match, 'params.config') || 'subGrantSummary';

    let subNavItems = _.includes(this.props.toggles, 'enableSubgrantSectionOnSGLP')
      ? SUBGRANTS_LANDING_PAGE_NAV_ITEMS_WITH_SUBGRANT
      : SUBGRANTS_LANDING_PAGE_NAV_ITEMS;
    let defaultNavItem = _.find(
      subNavItems,
      (navItem) => defaultConfig.toLowerCase() === navItem.toLowerCase()
    );

    const token = this.props.token;

    this.props
      .getDynamicDataByEntityId(token, subGrantNumber)
      .then((res) => {
        if (res && res.type === DYNAMIC_DATA_GET_ENTITY_SUCCESS) {
          /* 
            GMMGO-20709
            If the  subgrant TO and FROM themselves, then child organizations
            whose subOrgIds do not match should not be able to view the subgrant.
            Example: if subgrant was submitted from org 53242 and to 53242, then a child org of 51242
            shouldn't be able to view the subgrant.
          */

          const permissionsData = new PermissionsUtility(token);
          const entityIds = _.uniq(permissionsData.entityTypeIdList);

          const smaOrSmu = [ROLE_MAP.SMA.code, ROLE_MAP.SMU.code];
          const isSmaOrSmu = permissionsData.hasAnySystemRole(smaOrSmu);

          const shouldView =
            isSmaOrSmu ||
            permissionsData.hasPermsForSubOrgOrEntity(
              _.get(res, 'payload.organizationId'),
              [ENTITY_MAP.PROGRAM.code]
            ) ||
            permissionsData.hasPermsForFundingOpportunity(
              _.get(res, 'payload.fundingOpportunityId')
            );

          const isUserExternal = isExternal(this.props.permissions);

          const userHasProgramId = _.includes(
            permissionsData.getPrograms(),
            _.toString(_.get(res, 'payload.programId'))
          );

          const isProgramOrganizationUser = _.includes(
            entityIds,
            ENTITY_MAP.PROGRAM_ORGANIZATION.code
          );

          const hasProgramExternalRole = isProgramExternal(this.props.permissions);

          const resPayload = _.get(res, 'payload', {});

          /*
            Subgrant subOrgId and organizationId are equal and user shouldn't view OR
            external user lacks programId for the subgrant
          */
          if (
            (!userHasProgramId && isUserExternal && isProgramOrganizationUser) ||
            (!userHasProgramId && hasProgramExternalRole) ||
            (_.isEqual(resPayload.subOrgId, resPayload.organizationId) &&
              !shouldView &&
              !hasProgramExternalRole)
          ) {
            this.setState({
              loading: false,
              error: true,
            });
          } else {
            this.setState(
              {
                subGrantData: res.payload,
              },
              () => {
                this.updateSelection(defaultNavItem, defaultConfig);
              }
            );
          }
        } else {
          this.setState({
            loading: false,
            error: true,
          });
        }
        return res;
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: true,
        });
      });
  }

  updateSelection = (selectedMenuItem, configName) => {
    if (configName !== _.get(this.state, 'config.configType')) {
      this.setState({
        activeNavItem: selectedMenuItem,
      });
      return this.getConfig(configName)
        .then((config) => {
          this.setState(
            {
              config,
              loading: false,
            },
            () => {
              // when we change views, scroll back to the top
              window.scrollTo(0, 0);
            }
          );
          return config;
        })
        .catch((err) => {
          this.setState({
            error: true,
            loading: false,
          });
          return {};
        });
    } else {
      return new Promise((resolve) => {
        resolve(this.state.config);
      });
    }
  };

  renderGrantNotFound() {
    const {subGrantNumber, grantNumber} = this.props.match.params;
    const grantTypeFromPath = _.nth(_.split(_.get(this.props.match, 'path'), '/'), 1);
    const grantOrSubgrant =
      _.toLower(grantTypeFromPath) === _.toLower(ENTITY_PAGE_TYPE_SUBGRANT)
        ? _.toLower(ENTITY_PAGE_TYPE_SUBGRANT)
        : _.toLower(ENTITY_PAGE_TYPE_GRANT);
    const grant_or_subgrant_number = !_.isUndefined(subGrantNumber)
      ? subGrantNumber
      : grantNumber;

    return (
      <Error
        message={`No ${grantOrSubgrant} was found with identifier: ${grant_or_subgrant_number}.`}
      />
    );
  }

  scrollToParam = () => {
    const params = queryString.parse(_.get(this.props, 'location.search'));
    const elementId = _.get(params, 'scrollTo');
    if (document.querySelector(`#${elementId}`))
      document.getElementById(elementId).scrollIntoView();
  };

  getConfig = (configName) => {
    const {grantData, subGrantData} = this.state;

    let fundingOpportunityId = !_.isEmpty(grantData)
      ? _.get(grantData, 'fundingOpportunityId')
      : _.get(subGrantData, 'fundingOpportunityId');

    if (!_.isEmpty(this.state.allConfigs[configName])) {
      return new Promise((resolve, reject) => {
        resolve(this.state.allConfigs[configName]);
      });
    }
    return this.props
      .getConfig(
        this.props.token,
        'fo',
        fundingOpportunityId,
        'objectDefinition',
        configName
      )
      .then((res) => {
        if (res && res.type === API_CONFIG_GET_SUCCESS) {
          let configs = _.cloneDeep(this.state.allConfigs);
          configs[configName] = res.payload;
          this.setState({allConfigs: configs});
          return res.payload;
        } else {
          return Promise.reject();
        }
      });
  };

  renderSideNav() {
    const {grantData, subGrantData} = this.state;
    return (
      <Left expanded={this.state.leftExpanded} toggle={this.toggleLeft}>
        <GrantLandingSideNav
          updateSelection={(selectedMenuItem, configName) =>
            this.updateSelection(selectedMenuItem, configName)
          }
          grantId={this.state.grantData.id || this.state.subGrantData.grantId}
          subGrantId={this.state.subGrantData.entityId}
          activeNavItem={this.state.activeNavItem}
          location={this.props.currentLocation}
          getConfig={this.getConfig}
          config={this.state.config}
          toggles={this.props.toggles}
        />
      </Left>
    );
  }

  renderMain() {
    const {config} = this.state;
    const {message} = this.props;
    let initData = {
      grantId: this.props.match.params.grantNumber,
      subGrantId: this.stripInvalidParams(this.props.match.params.subGrantNumber),
    };
    return (
      <Main leftOffset={this.state.leftExpanded} leftCollapsed={!this.state.leftExpanded}>
        {!_.isEmpty(message) && <Alert header={message} type="success" dismissable />}
        {/* Pass in a {payload: {grantId: grantId}}*/}
        <SummaryPage config={config} data={initData} />
      </Main>
    );
  }

  toggleLeft = () => {
    this.setState({leftExpanded: !this.state.leftExpanded});
  };

  render() {
    const {loading, error} = this.state;
    this.scrollToParam();

    const sideNav = this.renderSideNav();

    const mainContent = this.renderMain();

    const noGrantFound = this.renderGrantNotFound();

    return (
      <React.Fragment>
        {!loading && !error && (
          <React.Fragment>
            {sideNav}
            {mainContent}
          </React.Fragment>
        )}
        {loading && !error && <Loader active>Loading...</Loader>}
        {error && noGrantFound}
      </React.Fragment>
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    getGrantByGrantNumber: (token, number) => {
      const action = ApiActions.grant.getGrantByGrantNumber(token, number);
      const response = dispatch(action);
      return response;
    },
    getDynamicDataByEntityId: (token, number) => {
      let action = ApiActions.dynamicData.getDataByEntityId(token, number);
      const res = dispatch(action);
      return res;
    },
    getConfig: (token, entityType, entityId, configType, configId) => {
      let action = ApiActions.config.getConfig(
        token,
        entityType,
        entityId,
        configType,
        configId
      );
      const response = dispatch(action);
      return response;
    },
    clearAllMsg: () => {
      dispatch({type: CLEAR_ALL_MSG});
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    token: _.get(state, 'auth.token'),
    currentLocation: _.get(state, 'dynamicComponent.currentLocation'),
    message: _.get(state, 'messages.messages'),
    toggles: state.toggles.toggles,
    permissions: _.get(state, 'auth.permissions'),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GrantLandingPage);
